module.exports = __webpack_public_path__ + "assets/img/zh-cn.a992e237.png";